export default __webpack_public_path__ + "static/media/exit.eeaa01ca.png";